import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { EReducers, IReducers } from 'app/store/reducers';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SessionService } from 'app/store/services/session.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Button, ButtonColor, ButtonSize } from 'app/store/models/button.model';
import { createDate, deleteDate, loadBlockedDates, refreshDates } from 'app/store/actions/campaigns.action';
import { EBlockedDatesStateStatus, IDates, IDatesState } from 'app/store/models/campaigns.model';
import { IUserSessionData, UserType } from 'app/store/models/user.model';
import { TimezonePipe } from '../../shared/ui/pipes/timezone.pipe';
import { UtilitiesService } from '../../store/services/utilities.servive';

@Component({
  selector: 'app-blocked-dates',
  templateUrl: './blocked-dates.component.html',
  styleUrls: ['./blocked-dates.component.scss'],
})
export class BlockedDatesComponent implements OnInit, OnDestroy {
  formGroup: FormGroup;

  submitDisabled = true;

  dates: IDates[];

  sessionData: IUserSessionData;

  deleteDateButton: Button = {
    color: ButtonColor.RED,
    text: 'Remove',
    size: ButtonSize.SMALL,
    onClick: item => this.delete(item),
  };

  systemDates: string[] = [];

  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private store: Store<IReducers>,
    private sessionService: SessionService,
    private readonly utilService: UtilitiesService,
  ) {
    this.formGroup = new FormGroup({
      action: new FormControl('', [Validators.required]),
    });
  }

  submit() {
    if (this.formGroup.controls.date.value === '') {
      return false;
    }

    if (typeof this.dates === 'object') {
      this.dates = Object.keys(this.dates).map(k => this.dates[k]);
    }

    const arr = [...this.dates];
    const formData = this.formGroup;
    const datePipe = new TimezonePipe(this.utilService);
    arr.push(
      datePipe.transform(
        formData.controls.date.value,
        'YYYY-MM-DD',
        this.sessionData.time_zone,
      ) as any,
    );

    this.store.dispatch(
      createDate({
        dates: arr,
        accountId: this.sessionData.id,
        isManager: this.sessionData.user_type === UserType.MANAGER,
      }),
    );
    this.formGroup.controls.date.setValue('');
  }

  delete(item) {
    const arr = this.dates;
    arr.splice(item, 1);
    this.store.dispatch(
      deleteDate({
        dates: arr,
      }),
    );
  }

  ngOnInit() {
    this.formGroup = new FormGroup({
      date: new FormControl('', []),
    });

    this.formGroup.valueChanges.subscribe(() => {
      if (this.formGroup.controls.date.value !== '') {
        this.submitDisabled = false;
      } else {
        this.submitDisabled = true;
      }
    });

    this.sessionService
      .onReady()
      .pipe(takeUntil(this.destroy$))
      .subscribe((sessionData: IUserSessionData) => {
        this.sessionData = sessionData;
        this.store.dispatch(
          loadBlockedDates({
            pagination: {
              current_page: 1,
              page_size: 10,
            },
          }),
        );
        this.store
          .select(EReducers.BLOCKED_DATES)
          .pipe(takeUntil(this.destroy$))
          .subscribe((state: IDatesState) => {
            if (state.status === EBlockedDatesStateStatus.UPDATED) {
              this.store.dispatch(
                refreshDates({
                  pagination: state.pagination,
                }),
              );
            }

            if (state.items) {
              this.dates = state.items;
            }

            if (state.extra_data) {
              this.systemDates = state.extra_data;
            }
          });
      });
  }

  ngOnDestroy() {
    this.destroy$.next(false);
  }
}
